import jsPDF from "jspdf";
import html2canvas from "html2canvas";

// window.print() is a no-op inside an iOS home-screen (standalone) PWA — a long-standing
// WebKit limitation. Detect that case and generate a real PDF instead so "Print / Save PDF"
// always does something. Everywhere else (desktop, Android, Safari tab) the native print
// dialog works fine and honours the @media print rules.
const isIOSStandalone = () => {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  const standalone = window.navigator.standalone === true ||
    window.matchMedia("(display-mode: standalone)").matches;
  return isIOS && standalone;
};

export const printOrSavePdf = async (elementId, filename = "report.pdf") => {
  const el = document.getElementById(elementId);
  if (!isIOSStandalone() || !el) {
    window.print();
    return "print";
  }
  const canvas = await html2canvas(el, { scale: 2, backgroundColor: "#ffffff", useCORS: true });
  const pdf = new jsPDF({ unit: "pt", format: "a4" });
  const pageH = pdf.internal.pageSize.getHeight();
  const imgW = pdf.internal.pageSize.getWidth();
  const imgH = (canvas.height * imgW) / canvas.width;
  const img = canvas.toDataURL("image/png");
  if (imgH <= pageH) {
    pdf.addImage(img, "PNG", 0, 0, imgW, imgH);
  } else {
    // Tall report: place the full image and shift it up one page at a time (clipped by the page).
    let remaining = imgH;
    let position = 0;
    while (remaining > 0) {
      pdf.addImage(img, "PNG", 0, position, imgW, imgH);
      remaining -= pageH;
      if (remaining > 0) { pdf.addPage(); position -= pageH; }
    }
  }
  pdf.save(filename);
  return "pdf";
};
